document.addEventListener("DOMContentLoaded", () => {
  const filterToggle = document.querySelector(".filter-toggle");
  const filterOffcanvas = document.querySelector(".filter-offcanvas");
  const filterOffcanvasClose = document.querySelector(
    ".filter-offcanvas-close"
  );
  const filterOffcanvasOverlay = document.querySelector(
    ".filter-offcanvas-overlay"
  );
  const filterOffcanvasContent = document.querySelector(
    ".filter-offcanvas-content"
  );
  const filterForm = document.getElementById("products-filter-form");
  const clearFilterBtn = document.querySelector(".clear-filter");

  const getScrollbarWidth = () => {
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  };

  const openOffcanvas = (e) => {
    e.preventDefault();
    const scrollbarWidth = getScrollbarWidth();
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    filterOffcanvas.classList.add("active");
    filterToggle.classList.add("active");
    document.body.classList.add("offcanvas-open");
  };

  const closeOffcanvas = (e) => {
    if (e) e.preventDefault();
    filterOffcanvas.classList.remove("active");
    filterToggle.classList.remove("active");
    setTimeout(() => {
      document.body.classList.remove("offcanvas-open");
      document.body.style.paddingRight = "";
    }, 300);
  };

  // Event Listeners
  if (filterToggle && filterOffcanvas) {
    filterToggle.addEventListener("click", openOffcanvas);
    filterOffcanvasClose.addEventListener("click", closeOffcanvas);

    // Close when clicking overlay or outside content
    filterOffcanvas.addEventListener("click", (e) => {
      if (e.target === filterOffcanvas || e.target === filterOffcanvasOverlay) {
        closeOffcanvas();
      }
    });

    // Prevent clicks inside content from closing
    filterOffcanvasContent.addEventListener("click", (e) =>
      e.stopPropagation()
    );

    // Handle form submission
    filterForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const formData = new FormData(filterForm);

      // Update URL with filter parameters
      const params = new URLSearchParams(window.location.search);
      for (const [key, value] of formData.entries()) {
        if (value) params.set(key, value);
        else params.delete(key);
      }

      window.location.search = params.toString();
    });

    // Handle clear filters
    clearFilterBtn.addEventListener("click", (e) => {
      e.preventDefault();
      filterForm.reset();
      window.location.href = window.location.pathname;
    });

    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && filterOffcanvas.classList.contains("active")) {
        closeOffcanvas();
      }
    });
  }
});
